import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		className: "icon-fill-secondary",
		d: "M33.6 10.7V8.2c1.2 0 1.7-.3 2.4-.7.8-.4 1.8-1 3.6-1V9c-1.2 0-1.7.3-2.4.7-.8.4-1.8 1-3.6 1zM45 7.6l-5.3-3.7v7.4zm-29.2.3h5.4v2.5h-5.4zm8 0h5.4v2.5h-5.4zm-8 12.8h5.4v2.5h-5.4zm8 0h5.4v2.5h-5.4zm9.8 2.8V21c1.2 0 1.7-.3 2.4-.7.8-.4 1.8-1 3.6-1v2.5c-1.2 0-1.7.3-2.4.7-.8.5-1.8 1-3.6 1zm11.4-3l-5.3-3.7v7.3zm-33.6-9.8c-1.8 0-2.8-.5-3.6-1-.7-.4-1.3-.7-2.4-.7V6.5c1.8 0 2.8.5 3.6 1 .7.4 1.2.7 2.4.7v2.5zM0 7.6l5.3-3.7v7.4zm11.4 15.9c-1.8 0-2.8-.5-3.6-1-.7-.4-1.2-.7-2.4-.7v-2.5c1.8 0 2.8.5 3.6 1 .7.4 1.2.7 2.4.7v2.5zM0 20.5l5.3-3.7v7.3z"
	}), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M35.8 32.3h-1.3V0h-24v32.3H9.2v2.5H11L16.6 45h11.8L34 34.8h1.8v-2.5zM13 2.5h19v29.8H13V2.5zm13.9 40h-8.8l-4.2-7.6h17.3l-4.3 7.6z"
	})]
});
export default SvgIcon;
